import React from 'react';
import Icon from '../../../components/AppIcon';
import { trackMetricView, trackDashboardInteraction } from '../../../services/analyticsService';

const MetricCard = ({ 
  title, 
  value, 
  trend, 
  trendValue, 
  icon, 
  iconColor = 'var(--color-primary)',
  onClick 
}) => {
  const isPositive = trend === 'up';
  const trendColor = isPositive ? 'text-success' : 'text-error';
  const trendIcon = isPositive ? 'TrendingUp' : 'TrendingDown';

  return (
    <div 
      className={`bg-card rounded-lg p-4 md:p-6 shadow-sm border border-border transition-smooth hover-lift ${onClick ? 'cursor-pointer' : ''}`}
      onClick={() => {
        // Track metric card interaction
        trackMetricView(title, value);
        trackDashboardInteraction('metric_card', 'click', {
          metric_title: title,
          metric_value: value,
        });
        if (onClick) onClick();
      }}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
            {title}
          </p>
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground font-data">
            {value}
          </h3>
        </div>
        {icon && (
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-md bg-primary/10">
            <Icon name={icon} size={20} color={iconColor} />
          </div>
        )}
      </div>
      {trend && (
        <div className="flex items-center gap-2">
          <Icon name={trendIcon} size={16} className={trendColor} />
          <span className={`text-xs md:text-sm font-medium font-data ${trendColor}`}>
            {trendValue}
          </span>
          <span className="text-xs text-muted-foreground font-caption">vs last period</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;